<template>
  <div class="jl-account-log-wrap">
    <div class="jl-acc-log-box clearfix">
      <div class="item-left">
        <div class="item-box alt-left">
          <div class="text-title">
            <p>{{auctionInfo.logisticsNumber?'已发货':'未发货'}}</p>
          </div>
          <div class="text-info">
            <p class="text1">{{auctionInfo.logisticsName}}</p>
            <p class="text2">单号: {{auctionInfo.logisticsNumber}}</p>
          </div>
        </div>
      </div>
      <div class="item-right">
        <div class="item-box alt-right">
          <p class="text-title">收货信息</p>
          <div class="text-info">
            <div class="info-ground">
              <label class="info-label">收货人</label>
              <p class="text1">{{auctionInfo.logisticsAddress.consignee}}</p>
            </div>
            <div class="info-ground">
              <label class="info-label">联系方式</label>
              <p class="text1">{{auctionInfo.logisticsAddress.contactPhone}}</p>
            </div>
            <div class="info-ground">
              <label class="info-label">收货地址</label>
              <p class="text1">{{auctionInfo.logisticsAddress.shippingAddress}}</p>
            </div>
            <div class="info-ground">
              <label class="info-label">邮编</label>
              <p class="text1">{{auctionInfo.logisticsAddress.zipCode}}</p>
            </div>
            <div class="info-ground">
              <label class="info-label">备注</label>
              <p class="text1">{{auctionInfo.remark}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { orderDetail } from '@/api/order';
export default {
  name: 'accountOrderLogistics',
  data() {
    const orderId = this.$route.params.id;
    return {
      orderId: orderId,
      auctionInfo: { logisticsAddress: {} }
    };
  },
  methods: {
    getInfo() {
      orderDetail(this, () => {
        //console.log(this.auctionInfo);
      });
    }
  },
  created() {
    this.getInfo();
  }
};
</script>

<style lang="scss" scoped>
.jl-acc-log-box {
  .item-left {
    float: left;
    width: 35.5%;
  }
  .item-box {
    min-height: 450px;
    background: #fff;
    &.alt-left {
      position: relative;
      box-shadow: 9px 0 14px rgba(184, 184, 184, 0.1);
    }
  }
  .alt-left {
    padding: 40px;
    .text-title {
      padding-bottom: 38px;
      border-bottom: 1px solid #e0e0e0;
      p {
        position: relative;
        font-size: 24px;
        color: #12a624;
        padding-left: 20px;
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          width: 8px;
          height: 8px;
          background: #12a624;
          border-radius: 4px;
          margin-top: -4px;
        }
      }
    }
    .text-info {
      padding-top: 24px;
      .text1 {
        font-size: 18px;
        columns: #333;
        line-height: 25px;
      }
      .text2 {
        font-size: 14px;
        columns: #666;
        line-height: 25px;
      }
    }
  }
  .alt-right {
    padding: 24px 40px;
    .text-title {
      font-size: 18px;
      color: #333;
      padding-bottom: 18px;
      border-bottom: 1px solid #e0e0e0;
    }
    .text-info {
      padding-top: 15px;
      .info-ground {
        position: relative;
        padding-left: 105px;
        margin-bottom: 15px;
        height: 25px;
        .info-label {
          position: absolute;
          left: 0;
          top: 0;
          font-size: 14px;
          color: #333;
          line-height: 25px;
        }
        .text1 {
          font-size: 14px;
          color: #333;
          line-height: 25px;
        }
      }
    }
  }
  .item-right {
    float: right;
    width: 64.5%;
  }
}
</style>

